var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C7.34784 0 4.8043 1.05357 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C4.8043 18.9464 7.34784 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0Z",
    fill: "url(#paint0_linear_311_997)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2025 9.1725C15.4225 9.32625 15.625 9.47875 15.625 10.015C15.625 10.5525 15.3387 10.77 15.0325 10.9213C15.1577 11.1253 15.1976 11.3705 15.1437 11.6038C15.0475 12.0337 14.6537 12.3675 14.3038 12.4662C14.455 12.7087 14.5025 12.9475 14.3225 13.2413C14.0913 13.61 13.89 13.75 13 13.75H9.375C8.14 13.75 7.5 13.0675 7.5 12.5V9.58125C7.5 8.04375 9.33375 6.7375 9.33375 5.66875L9.20125 4.3375C9.195 4.25625 9.21125 4.0575 9.27375 4C9.37375 3.90125 9.65 3.75 10.0675 3.75C10.34 3.75 10.5213 3.80125 10.735 3.90375C11.4613 4.25 11.65 5.12625 11.65 5.83125C11.65 6.17 11.1325 7.185 11.0625 7.53625C11.0625 7.53625 12.1462 7.29625 13.4113 7.2875C14.7375 7.28 15.5975 7.525 15.5975 8.34C15.5975 8.66625 15.3237 8.99375 15.2025 9.1725ZM4.5 8.75H5.5C5.69891 8.75 5.88968 8.82902 6.03033 8.96967C6.17098 9.11032 6.25 9.30109 6.25 9.5V14.25C6.25 14.4489 6.17098 14.6397 6.03033 14.7803C5.88968 14.921 5.69891 15 5.5 15H4.5C4.30109 15 4.11032 14.921 3.96967 14.7803C3.82902 14.6397 3.75 14.4489 3.75 14.25V9.5C3.75 9.30109 3.82902 9.11032 3.96967 8.96967C4.11032 8.82902 4.30109 8.75 4.5 8.75Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_311_997",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0062DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.975b6ad1398c230cd3fd8273cb1a36a0.svg";
export { ForwardRef as ReactComponent };